<main-header></main-header>

<div class="main-page-container content-container">
  <section class="qt-pagehead" aria-labelledby="qt-title">
    <div>
      <span *ngIf="branchEndpointService?.details?.name as branchName" class="qt-pagehead__branch">
        <i class="header-icon --map-pin"></i>{{ branchName }}
      </span>
      <h1 id="qt-title" class="qt-pagehead__title">Select app view</h1>
      <p class="qt-pagehead__sub">Choose what this device should show.</p>
    </div>
    <div class="qt-pagehead__controls">
      <label class="qt-toggle">
        <span>
          <span class="qt-toggle__title">Auto redirect</span>
          <span class="qt-toggle__hint">Open the selected view automatically</span>
        </span>
        <input
          type="checkbox"
          role="switch"
          class="qt-switch__input"
          (click)="handleUseAutoRedirectChange()"
          (keyup)="handleUseAutoRedirectChange()"
          [checked]="autoRedirectMode"
          id="auto-redirect-check"
        />
        <span class="qt-switch" aria-hidden="true"></span>
      </label>
      <a class="qt-settings-btn" [routerLink]="['/settings']" title="Settings">
        <img src="/assets/images/settings.svg" alt="" /> Settings
      </a>
    </div>
  </section>
  <div class="menu-grid">
    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Printer</div>
        <div class="app-view-icon --printer">
          <div class="app-view-sub-icon">
            <span class="--small">USB</span>
            <i class="--usb-connection"></i>
          </div>
        </div>
        <app-touch-select
          [options]="printers"
          placeholder="Select printer"
          (selected)="onPrinterSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Monitor</div>
        <div class="app-view-icon --monitor"></div>
        <app-touch-select
          [options]="monitors"
          placeholder="Select monitor"
          (selected)="onMonitorSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Multi Queue Monitor</div>
        <div class="app-view-icon --multi-queue-monitor"></div>
        <app-touch-select
          [options]="monitors_overviews"
          placeholder="Select monitor"
          (selected)="onMonitorOverviewSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="queue device-wrapper">
        <div class="app-view-title">Dynamic Counter Display</div>
        <div class="app-view-icon --name-based-counter-display">
          <div class="app-view-sub-icon">
            <span>{{ '+1' }}</span>
            <i class="--single-counter-display"></i>
          </div>
        </div>
        <app-touch-select
          id="name-based-counter-display-id"
          [options]="nameBasedCounterOptions"
          placeholder="Select counter"
          (selected)="onNameBaseCounterSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="queue device-wrapper">
        <div class="app-view-title">Single Counter Display</div>
        <div class="app-view-icon --counter-display">
          <div class="app-view-sub-icon">
            <span>1</span>
            <i class="--single-counter-display"></i>
          </div>
        </div>

        <app-touch-select
          id="queue-display-id"
          [options]="queues"
          placeholder="Select queue"
          [twoStepMode]="true"
          [dependentOptions]="queue?.counters"
          [secondLoading]="countersLoading"
          [secondPlaceholder]="'Select a counter'"
          (firstSelected)="onConsoleQueueSelect($event)"
          (selected)="loadRoofCounter(queue, $event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Single Queue Display</div>
        <div class="app-view-icon --counter-display">
          <div class="app-view-sub-icon">
            <span>1</span>
            <i class="--single-queue-display"></i>
          </div>
        </div>
        <app-touch-select
          [options]="recent_queues"
          placeholder="Select queue"
          (selected)="onRecentQueueSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Dynamic Queue Display</div>
        <div class="app-view-icon --name-based-counter-display">
          <div class="app-view-sub-icon">
            <span>{{ '+1' }}</span>
            <i class="--single-queue-display"></i>
          </div>
        </div>
        <a
          class="touch-select-link"
          [routerLink]="['/branch', branchId, 'dynamic_queue_display']"
          (click)="handleToDynamicQueueClick()"
        >
          Open Dynamic Queue Display
        </a>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Queue Overview</div>
        <div class="app-view-icon --queue-overview"></div>

        <app-touch-select
          [options]="queue_overviews"
          placeholder="Select overview"
          (selected)="onQueueOverviewSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Feedback Stands</div>
        <div class="app-view-icon --feedback-view"></div>
        <app-touch-select
          [options]="feedback_stands"
          placeholder="Select feedback stand"
          (selected)="onFeedbackStandSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Single Queue Information</div>
        <div class="app-view-icon --single-queue-info-monitor"></div>
        <app-touch-select
          id="queue-display-id"
          [options]="queues"
          placeholder="Select queue"
          (selected)="onSingleQueueInfoSelect($event)"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Recent Serving Counters</div>
        <div class="app-view-icon --recent-serving-counters"></div>
        <app-touch-select
          [options]="recentServingCountersOptions"
          placeholder="Select number of counters"
          (selected)="onRecentServingCountersSelect($event)"
          [centerItemLabel]="true"
        ></app-touch-select>
      </div>
    </div>

    <div class="menu-item">
      <div class="device-wrapper">
        <div class="app-view-title">Flex</div>
        <div class="app-view-icon --flex"></div>
        <a class="touch-select-link" [routerLink]="['/view-board']" (click)="handleToFlexClick()"> Open Flex </a>
      </div>
    </div>
  </div>
</div>
